module.exports = __webpack_public_path__ + "media/assets/bookingSteps-644a588e298e1ecd992ca9cd74c0520d.png";